import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { TrendingUp } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';

const stageColors = [
  'bg-blue-50 text-blue-700 border-blue-200',
  'bg-cyan-50 text-cyan-700 border-cyan-200',
  'bg-sky-50 text-sky-700 border-sky-200',
  'bg-amber-50 text-amber-700 border-amber-200',
  'bg-orange-50 text-orange-700 border-orange-200',
  'bg-violet-50 text-violet-700 border-violet-200',
  'bg-purple-50 text-purple-700 border-purple-200',
  'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  'bg-emerald-50 text-emerald-700 border-emerald-200',
];

const CALL_STAGES = new Set(['nuovo', 'contattato']);

export const CommercialPipelineV2 = ({ stages = [], totalValue = 0, totalCount = 0 }) => {
  const navigate = useNavigate();
  const stageLink = (status) => (CALL_STAGES.has(status) ? '/leads?pipeline=call' : '/leads?pipeline=sales');

  return (
    <Card className="bg-white rounded-xl border border-[#E4E4E4] shadow-sm h-full flex flex-col" data-testid="direzione-pipeline">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-[#FF7819]" />
          Pipeline Commerciale
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {stages.length === 0 ? (
          <p className="text-sm text-gray-500 py-6 text-center">Nessuna opportunità attiva</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {stages.map((stage, idx) => (
              <button
                key={stage.status}
                onClick={() => navigate(stageLink(stage.status))}
                data-testid={`pipeline-stage-${stage.status}`}
                className={`text-left p-3 rounded-lg border transition-all hover:shadow-sm ${stageColors[idx % stageColors.length]}`}
              >
                <p className="text-xs font-medium leading-tight line-clamp-2 min-h-[2rem]" title={stage.label}>{stage.label}</p>
                <p className="text-xl font-bold mt-1 leading-none">{stage.count}</p>
                {stage.value > 0 && (
                  <p className="text-[11px] text-gray-500 mt-1 truncate" title={formatCurrency(stage.value)}>{formatCurrency(stage.value)}</p>
                )}
              </button>
            ))}
          </div>
        )}

        <div className="flex items-center justify-between pt-3 border-t border-gray-100 mt-3">
          <div>
            <p className="text-xs text-gray-500">Valore pipeline</p>
            <p className="text-lg font-bold text-[#3C3C3C]" data-testid="pipeline-total-value">{formatCurrency(totalValue)}</p>
          </div>
          <div className="text-right">
            <p className="text-xs text-gray-500">Opportunità attive</p>
            <p className="text-lg font-bold text-[#3C3C3C]" data-testid="pipeline-total-count">{totalCount}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
